module.exports = __webpack_public_path__ + "img/download-ios.77ca8b6d.png";